/*
 * Copyright (C) 2014 Spanning Cloud Apps.  All rights reserved.
 */
/**
 * Interceptor module for checking responses for the errors related to cookies.
 */
'use strict';

angular
  .module('interceptor.unauthorized', [])
  /**
   * A factory that registers the interceptor logic checking for errors related to cookies not being enabled.
   */
  .factory('unauthorizedInterceptor', function ($q, $rootScope, $filter, HTTP_ERROR_STATUS, ALERT_EVENTS) {
    return {
      // On response failure
      responseError: function (rejection) {
        if (rejection.status === HTTP_ERROR_STATUS.UNAUTHORIZED) {
          $rootScope.$emit(ALERT_EVENTS.UNAUTHORIZED.eventName);

          return rejection;
        } else {
          // Return the promise rejection for other errors.
          return $q.reject(rejection);
        }
      }
    };
  });
